import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { APPLICATION_SLOT_ADD_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class AddApplicationSlot extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = [];

  url = APPLICATION_SLOT_ADD_URL;

  constructor(reqData) {
    super();
    this.body = reqData.jointApplicants;
    const { applicationId } = reqData;
    const paramList = [applicationId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
